export default __webpack_public_path__ + "static/media/IMG_2736.6081a2aa.jpg";